module.exports = __webpack_public_path__ + "static/businesswire-a02a05b519468842e565aceafe593f23.png";